import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'

//import { SplitText } from "../components/SplitText";
import gsap from 'gsap'


class Textroll {

  constructor(element, ref, speed) {

    this.element = element
    this.el = $(element)
    this.speed = 2

    this.ref = ref || {
      track: null,
      elm: null
    }

    this.speed = speed || 2


    this.build()

  }

  build(){
    this.currentX = 0
    this.ref.track.appendChild(this.ref.elm.cloneNode(true))
  }

  mount() {
      document.fonts.ready.then(()=> {
      //  console.log('start resize');
        this.resize()

      })
      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.resize(stage);

  }


  stop(){
    this.isPlaying && renderer.remove(this)
    this.isPlaying = false
    //console.log('stop');
  }

  play(){
    !this.isPlaying && renderer.add(this)
    this.isPlaying = true
    //console.log('play');
  }


  resize(){
  //  console.log('do resize');
    this.w = this.ref.elm.offsetWidth

  }



  renderQueCall(){


    this.currentX -= this.speed
    if(this.currentX < -this.w) {
      this.currentX = 0
    }

    gsap.set(this.ref.track, {x:this.currentX, force3D: true})

  }

  unmount() {
    this.stop()
    stage.removeListener("stage:resize", this.resizeQue);
    //console.log("Unmount Text!");
  }


}

module.exports = Textroll
